import { WidgetsPerspective } from '~/components/MyWorkspace/ManagePerspectives';

type PerspectivesRolesMapping = {
  [key in WidgetsPerspective]: string[];
};

export const perspectivesRolesMapping: PerspectivesRolesMapping = {
  [WidgetsPerspective.EMPLOYEE]: ['EMPLOYEE'],
  [WidgetsPerspective.MANAGER]: ['MANAGER'],
  [WidgetsPerspective.RESPONSIBLE_MANAGER]: ['ALT_MANAGER', 'DEPUTY_MANAGER'],
  [WidgetsPerspective.RESPONSIBLE_HR]: [
    'HR_ADMIN',
    'HR_ADMIN_LIMITED',
    'HR_STAFF',
    'HR_DEV',
    'HR_SALARY',
  ],
};

export const filterRolesByPerspectives = (
  roles: string[],
  perspectives: WidgetsPerspective[],
): string[] => {
  return roles.filter((role) => {
    return perspectives.some((perspective) => {
      return perspectivesRolesMapping[perspective].includes(role);
    });
  });
};
